import React, { useState, useEffect } from "react";
import { Table, Container, Input, Row, Col, Button,Modal,ModalBody,ModalHeader } from 'reactstrap';
import './ProposalStyle.css';
import "./Reports.css";
import pdfFonts from "pdfmake/build/vfs_fonts";
import pdfMake from "pdfmake/build/pdfmake";
import CreateTableComponent from "../../share/CreateTableComponent";
import { NumberWithCommmas2 } from "../../share/NumberWithCommmas2";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export function Report60Component() {

    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re60data, setRe60data] = useState([]);
    const [openModalForm, setOpenModalForm] = React.useState(false);
    const [Re60detail, setRe60detail] = React.useState([]);
    const [status, setStatus] = React.useState("13");
    // const [R60detailfilter, setR60detailfilter] = React.useState([]);
    pdfMake.fonts = {
        THSarabunNew: {
            normal: 'THSarabunNew.ttf',
            bold: 'THSarabunNew Bold.ttf',
            italics: 'THSarabunNew Italic.ttf',
            bolditalics: 'THSarabunNewn BoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Medium.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-MediumItalic.ttf'
        }
    }

    async function getR60() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res60 = await fetch("/api/Support/getR60", {
            method: 'POST',
            body: formData
        })
        const Re60data = await res60.json()
        setRe60data(Re60data.dataenum);
        console.log(Re60data)
    }

    const [Re60yeardata, setRe60yeardata] = React.useState([]);

    async function getR60year() {
        const res = await fetch("/api/Support/getyear57")
        const Re60yeardata = await res.json()
        setRe60yeardata(Re60yeardata.dataenum)
        console.log(Re60yeardata)
    }


    const y2 = Re60yeardata.filter(n => n.yearTh >= othYearSelected);

    React.useEffect(() => {
        getR60()
        getR60year()
    }, [thYearSelected, othYearSelected]);


    

    //let sum = Re60data.reduce(function (prev, current) {
    //    return prev + +current.year1
    //}, 0);
    //let sumcompany = Re60data.reduce(function (prev, current) {
    //    return prev + +current.year2
    //}, 0);
    //let sumpersanal = Re60data.reduce(function (prev, current) {
    //    return prev + +current.year3
    //}, 0);
    //let sumamount = Re60data.reduce(function (prev, current) {
    //    return prev + +current.year4
    //}, 0);

   

    async function getR60detail(value, type) {
        const formData = new FormData();
        // console.log("thYearSelected",typeof thYearSelected);
        formData.append("thYear", thYearSelected);
        formData.append("status", String(type));
        // console.log("status",status);
        console.log("value", value);
        console.log("type", type);
        const res61 = await fetch("/api/Support/getR60detail", {
            method: 'POST',
            body: formData
        })
        const Re60data = await res61.json()
        setRe60detail(Re60data.dataenum);
        // setR60detailfilter(Re60data.dataenum.filter(
        //     (item) => item.supportDetail === value
        // ))
        console.log(Re60data);
        modalToggleExtendCourse();
    }

    const modalToggleExtendCourse = () => {
        // getR55detail()
        setOpenModalForm(!openModalForm);
        // console.log("idmodal", value);
    }

    const COLUMNSTRAIN = [
        {
            Header: "ลำดับ",
            accessor: (_row, i) => i + 1,
        },
        {
            Header: "ชื่อผู้ได้รับเงินช่วยเหลือหรืออุดหนุน",
            accessor: "supportName",
        },
        {
            Header: "เลขที่คำขอ",
            accessor: "supportNo",
        },
        {
            Header: "จำนวนคน",
            accessor: "personTotal",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
        {
            Header: "จำนวนเงินที่จ่ายเงินอุดหนุนแล้ว (บาท)",
            accessor: "amount",
            Cell: ({ value }) => {
                return (
                    <>
                        {NumberWithCommmas2(value)}

                    </>
                )

            }
        },
    ]

    return (
        <Container>
            <div>
                <div style={{ display: 'flex', paddingBottom: '20px' }}>
                    <h3 className='text-center' style={{ lineHeight: 'inherit' }}>
                     ปีงบประมาณ พ.ศ. 
                    </h3>
                <Input
                    style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                    id="othYear"
                    name="othYear"
                    type="select"
                    value={othYearSelected}
                    onChange={(e) => {
                        setOThYearSelected(e.target.value)
                    }}
                >
                        {Re60yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                </Input>
                <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                <Input
                    style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                    id="thYear"
                    name="thYear"
                    type="select"
                    value={thYearSelected}
                    onChange={(e) => {
                        setThYearSelected(e.target.value)
                    }}
                >
                        {y2.map((item , i) => (
                            <option value={item.yearTh}> 
                                {item.yearTh}
                            </option> 

                        ))}
                   
                </Input>
            </div>
            <Row>
                <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/Support/xlsxR60?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn1" href={`api/SupportReports/excelR60detail?thYear=${thYearSelected}&status=${status}&othYear=${othYearSelected}`} download>EXCEL(Detail)</Button>
                        <Button className="btn2" href={`api/Support/pdfR60?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                </Col>
            </Row>
                <div className="outer-wrapper">
                    <div className="table-wrapper">
                    <Table className="styled-table" bordered striped hover>
                    <thead>
                        <tr>
                            <th rowSpan="3">
                                ปีงบประมาณ
                            </th>
                            <th rowSpan="3" className='text-center'>
                                จำนวนเงินงบประมาณ (บาท)
                            </th>
                            <th colSpan="3" className=' text-center'>
                                อนุมัติเงินช่วยเหลือหรืแอุดหนุน
                            </th>
                            <th rowSpan="3" className=' text-center'>
                               ร้อยละ
                            </th>
                            <th rowSpan="3" className=' text-center'>
                                งบประมาณคงเหลือ
                            </th>
                            <th rowSpan="3" className=' text-center'>
                                ร้อยละ
                            </th>
                        </tr>
                        <tr>
                            <th colSpan="1" className='text-center'>
                                (แห่ง)
                            </th>
                            <th colSpan="1" className='text-center'>
                                คน
                            </th>
                            <th colSpan="1" className='text-center'>
                                (บาท)
                            </th>
                            
                        </tr>
                   
                      
                    </thead>

                            <tbody>
                                {Re60data.length > 0 && Re60data.map((item, i) => (
                                    <tr >
                                       
                                        <td className='text-center'>
                                            {item.yearth}  (ต.ค.  {item.yearth-1} - ก.ย. {item.yearth}  )
                                        </td>
                                        <td className='text-end'>
                                            {item.year1}
                                        </td>
                                        <td className='text-end'>
                                        <p className="border-0 text-black btn btn-outline-light" type="button" id={item.year1}
                                                onClick={(e) => {
                                                    getR60detail(e.target.id, "0")
                                                }}>{Number(item.year2)}</p> 
                                            {/* {item.year2} */}
                                        </td>
                                        <td className='text-end'>
                                            {item.year3}
                                        </td>
                                        <td className='text-end'>
                                            {item.year4}
                                        </td>

                                        <td className='text-end'>
                                            {item.per}%
                                        </td>
                                        <td className='text-end'>
                                            {item.ba}
                                        </td>
                                        <td className='text-end'>
                                            {item.per2}%
                                        </td>
                                     
                                    </tr>

                                )) || <tr><td colSpan="8" rowSpan="6" className='text-center'>No Data</td></tr>}
                                {/*<tr>*/}
                                {/*    <td colSpan="1" className='text-end'>*/}
                                {/*        รวมงบประมาณ {othYearSelected} - {thYearSelected}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sum}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumcompany}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumpersanal}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        {sumamount}*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        -*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        -*/}
                                {/*    </td>*/}
                                {/*    <td className='text-center'>*/}
                                {/*        -*/}
                                {/*    </td>*/}

                                {/*</tr>*/}

                            </tbody>

                </Table>
                    </div>
                </div>       
            </div>

            <Modal

                isOpen={openModalForm}
                toggle={modalToggleExtendCourse}
                // style={{ maxWidth: "600px", width: "100%" }}
                centered
                scrollable
                backdrop={'static'}
                keyboard={false}
                size="xl"

                className="modal-bordered"
            >
                <ModalHeader toggle={modalToggleExtendCourse} className="styled-modal text-center">
                    รายละเอียดข้อมูล
                </ModalHeader>
                <ModalBody >
                    <CreateTableComponent column={COLUMNSTRAIN} dataInput={Re60detail} showEntrie={true} showPage={true} />
                </ModalBody>
            </Modal>

        </Container>

       
    )
}